// const apihost = '/ajax';
const apihost = "/ajax"
const apihost1 = "/api"
const feehost = 'http://tpapi.iprtt.com/';
// const  BASE_URL ="window.location.href"

export default {
	baseuri: apihost,
	common: {
		info: apihost + "/AbpUserConfiguration/GetAll",
		login: apihost + "/login",
		logOut: apihost + "/logout"
	},
	search: {
		aggs: apihost + "/aggs",
		skey: apihost + "/s",
		// parted: apihost + "/patent/base", //专利信息
		info: apihost + "/base",
		sug: apihost + "/suggest",
		claims: apihost + "/claims",
		description: apihost + "/description",
		drawings: apihost + "/drawings",
		info1: apihost + "/info",
		like: apihost + "/like",
		pdf: apihost + "/pdf",
		family: apihost + "/family",
		extendedFamily: apihost + "/extendedFamily",
		citing: apihost + "/citing",
		transaction: apihost + "/transaction",
		law: apihost + "/law",
		joinSpace: apihost + "/search/add/workspace",
		saveStrategy: apihost + "/user/search_strategy",
		strategyList: apihost + "/search_strategy",
		strategyCount: apihost + "/search_strategy/count",
		strategyEdit: apihost + "/user/search_strategy/rename",
		strategyMerge: apihost + "/user/search_strategy/merge",
		strategyView: apihost + "/viewss",
		historyList: apihost + "/shv/list",
		pdfDown: apihost,
		pdfDown1: apihost + "/d/pdf",
		taskPro: apihost + "/task/",
		zhulu: apihost + "/d/p",
		searchLike: apihost + "/search/like",
		img: apihost + "/search/image",
		upload: apihost + "/search/image/upload",
		delshv: apihost + "/delete_search_history",
		ipcList: apihost + "/ipc/search",
		ipcChild: apihost + "/ipc/load_children",
		comp: apihost + "/company/search",
		compChild: apihost + "/company/load_children"
	},
	widgets: {
		wordMap: apihost + "/worldMap"
	},
	space: {
		index: apihost + "/workspace/index",
		fields: apihost + "/workspace/fields",
		new: apihost + "/workspace/new",
		edit: apihost + "/workspace/edit",
		del: apihost + "/workspace/delete",
		info: apihost + "/workspace/info",
		special: apihost + "/workspace/specials",
		collect: apihost + "/workspace/specials/favorite/add",
		cancel: apihost + "/workspace/specials/favorite/remove",
		addShare: apihost + "/workspace/share/create",
		getdesc: apihost + "/workspace/folder/comment/get",
		updesc: apihost + "/workspace/folder/comment/update",
		deldesc: apihost + "/workspace/folder/comment/delete",
		adddesc: apihost + "/workspace/folder/comment/add",
		searchUser: apihost + "/search",
		sharedList: apihost + "/workspace/share",
		createShare: apihost + "/workspace/share/create",
		delShare: apihost + "/workspace/share/delete"
	},
	folder: {
		list: apihost + "/workspace/folders",
		setting: apihost + "/workspace/setting/folder",
		new: apihost + "/workspace/folder/new",
		newChild: apihost + "/workspace/folder/get",
		del: apihost + "/workspace/folder/delete",
		batchdel: apihost + "/workspace/folder/batch_delete",
		edit: apihost + "/workspace/folder/edit"
	},
	analysis: {
		ration: apihost + "/analysis/ration",
		analyse: apihost + "/analysis/ration/analysis",
		list: apihost + "/analysis/ration/list",
		save: apihost + "/analysis/ration/save",
		ur: apihost + "/analysis/ration/ur",
		info: apihost + "/analysis/ration/info",
		saveCustom: apihost + "/analysis/ration/custom/save",
		portrait: apihost + "/analysis/enterprise/portrait",
		customsave: apihost + "/analysis/ration/custom/save",
		customList: apihost + "/analysis/ration",
		delete: apihost + "/analysis/ration/delete",
		update: apihost + "/analysis/ration/update",
		cusUpdate: apihost + "/analysis/ration/custom/update"
	},
	user: {
		info: apihost + "/center/personal"
	},
	report: {
		info: apihost + "/report/base/index",
		create: apihost + "/report/base/create_report",
		new: apihost + "/report/base/new",
		search: apihost + "/report/base/search",
		spaceSubmit: apihost + "/report/base/workspace/submit",
		companySubmit: apihost + "/report/base/company/submit",
		techSubmit: apihost + "/report/base/technology/submit",
		filterAnaly: apihost + "/report/",
		sendEmail: apihost + "/report/base/",
		download: apihost + "/report/base/",
		delete: apihost + "/report/base/delete_report"
	},
	chome: {
		chartGroup: apihost + "/custchart/group/chart/list",
		chartData: apihost + "/custchart/group/chart/data",
		chartsummary: apihost + "/custchart/group/chart/summary"
	},
	manage: {
		companies: apihost + "/custchart/group/companies",
		manageUpdate: apihost + "/custchart/group/company/update",
		manageAdd: apihost + "/custchart/group/company/add",
		manageDelete: apihost + " /custchart/group/company/delete",
		manageSearch: apihost + "/custchart/group/company/search",
		manageCompanyindex: apihost + "/custchart/group/companyindex",
		managePatent: apihost + "/patent/base",
        manageEnterprise: apihost +  "/custchart/group/com/enterprise",
	},
	category: {
			chartGroup: apihost + "/custchart/group/chart/list",
			chartData: apihost + "/custchart/group/chart/data",
			reportData: apihost + "/custchart/group/report",
			reportVipcoms: apihost + "/custchart/group/vipcoms/companyindex",
	},
	manager: {
		mindex: apihost + "/annual/index",
		mchart: apihost + "/annual/portrait",
		monitorIndex: apihost + "/annual/monitor/index",
		apIndex: apihost + "/annual/monitor/ap/index",
		apAdd: apihost + "/annual/monitor/ap/add",
		apDel: apihost + "/annual/monitor/ap/deleted",
		notiPersonList: apihost + "/annual/target/index",
		notiPersonAdd: apihost + "/annual/target/add",
		notiPersonDel: apihost + "/annual/target/delete",
		notiPersonClose: apihost + "/annual/target/close",
		notiPersonUpdate: apihost + "/annual/target/update",
		msgList: apihost + "/annual/notification/index",
		msgDetail: apihost + "/annual/notification/detail",
		msgRead: apihost + "/annual/notification/reads",
		downLoad: apihost + "/annual/monitor/export/patent",
		feeInfo: apihost + "/annual/monitor/feeInfo",
		addMonitor: apihost + "/annual/monitor/add/Monitor",
		ercode: apihost + "/annual/target/wx_care_qrcode",
		feeExport: apihost + '/annual/monitor/export',
		delPatent: apihost + '/annual/monitor/delete'
	},
	fee: {
		feeInfoParam: apihost + "/annual/monitor/feeInfoParam",
        client: feehost + '/client/QueryFeeInfos',
        queue: feehost + '/api/AddToQueue',
        info: feehost + '/client/QueryJsonData'
    },
    knowledge:{
		knowTradPa: apihost +"/custchart/group/com/pa",
        knowTrademark: apihost + "/custchart/group/com/tm",
        knowTradeRz: apihost + "/custchart/group/com/rz",
        knowTradeCert: apihost + "/custchart/group/com/cert",
        knowTradeStd: apihost + "/custchart/group/com/std",
    }
}
